// extracted by mini-css-extract-plugin
export var borderRadius = "_fw-4";
export var large = "_fw-3";
export var logoContainer = "_fw-0";
export var nameLogo = "_fw-2";
export var small = "_fw-1";